export const getReadableFailReason = (failReason?: string): string => {
  if (!failReason) return 'N/A';

  const map: Record<string, string> = {
    authentication_error: 'Authentication Error',
    blocked_by_provider: 'Blocked by Provider',
    error_creating_clear_member: 'Error Creating CLEAR Member',
    ip_blocked: 'IP Blocked',
    ineligible: 'Ineligible'
  };

  return (
    map[failReason.toLowerCase()] ??
    failReason.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
  );
};
